import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography, Paper, Grid, Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { UserSettings } from 'components/src/store/reducers/userDataReducer';
import { downloadProductReportApi } from '../../api';
import { connect } from 'react-redux';

const ProductReportDownloadPage: React.FC = (props: any) => {
    const selectedBusiness = useSelector(
        (state: { userData: UserSettings }) => props.userData.selectedBusiness
    );
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleDownload = async () => {
        if (!selectedBusiness || !selectedBusiness.business_id) {
            enqueueSnackbar('Business ID is missing.', { variant: 'error' });
            return;
        }
        setIsLoading(true);
        try {
            const response = await downloadProductReportApi(selectedBusiness.business_id);

            if (!response.ok) {
                let errorMessage = `Failed to download report. Status: ${response.status}`;
                try {
                    if (response.headers.get('content-type')?.includes('application/json')) {
                        const errorData = await response.json();
                        if (errorData && errorData.error) {
                            errorMessage = errorData.error;
                        }
                    } else {
                        const errorText = await response.text();
                        if (errorText) {
                            errorMessage = errorText;
                        }
                    }
                } catch (e) {
                    console.error('Error parsing error response:', e);
                }
                enqueueSnackbar(errorMessage, { variant: 'error' });
                setIsLoading(false);
                return;
            }
            
            const blob = await response.blob();
            const contentDisposition = response.headers.get('content-disposition');
            let filename = `product-report-${selectedBusiness.business_id}.csv`; // Default filename

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch.length > 1) {
                    filename = filenameMatch[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);

            enqueueSnackbar('Report download started.', { variant: 'success' });
        } catch (error: any) {
            console.error('Error downloading product report:', error);
            enqueueSnackbar(error.message || 'Failed to download report.', { variant: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    if (!selectedBusiness || !selectedBusiness.business_id) {
        return (
            <Paper style={{ padding: '20px' }}>
                <Typography variant="h6" color="error">
                    No business selected. Please select a business to download the report.
                </Typography>
            </Paper>
        );
    }

    return (
        <Paper style={{ padding: '20px' }}>
            <Grid container spacing={3} direction="column">
                <Grid item>
                    <Typography variant="h5">Product CSV Report</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body1">
                        Click the button below to download the full product report as a CSV file for the selected business: <strong>{selectedBusiness.business_name}</strong> (ID: {selectedBusiness.business_id}).
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownload}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Downloading...' : 'Download Product Report'}
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = (state: any) => {
    return {
      userData: state.userLocalData,
    };
  };
  export default connect(mapStateToProps, null)(ProductReportDownloadPage);
  